"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Search = function Search(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#FFFFFF",
    d: "M1413.15266,71.0943396 L1412.06861,71.0943396 L1411.68439,70.7238422 C1413.02916,69.1595197 1413.83877,67.1286449 1413.83877,64.9193825 C1413.83877,59.9931389 1409.84563,56 1404.91938,56 C1399.99314,56 1396,59.9931389 1396,64.9193825 C1396,69.8456261 1399.99314,73.838765 1404.91938,73.838765 C1407.12864,73.838765 1409.15952,73.0291595 1410.72384,71.6843911 L1411.09434,72.0686106 L1411.09434,73.1526587 L1417.9554,80 L1420,77.9554031 L1413.15266,71.0943396 Z M1404.91938,71.0943396 C1401.50257,71.0943396 1398.74443,68.3361921 1398.74443,64.9193825 C1398.74443,61.5025729 1401.50257,58.7444254 1404.91938,58.7444254 C1408.33619,58.7444254 1411.09434,61.5025729 1411.09434,64.9193825 C1411.09434,68.3361921 1408.33619,71.0943396 1404.91938,71.0943396 Z",
    transform: "translate(-1396 -56)"
  }));
};

var _default = Search;
exports["default"] = _default;